/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILdsHeaderConfig } from '../lds-header.data';

export const HeaderImages: React.FC<ILdsHeaderConfig> = props => {
    const churchLogoLink = props.churchLink ? props.churchLink : '';
    const churchLogoImage = props.churchImage ? props.churchImage : '';

    const storeLogoLink = props.storeLink ? props.storeLink : '';
    const storeLogoImage = props.storeImage ? props.storeImage : '';

    return (
        <div className='LdsHeader'>
            <div className='LdsHeaderImageWrapper'>
                <a className='ChurchLogo' href={churchLogoLink ? churchLogoLink.linkUrl.destinationUrl : ''}>
                    <img
                        src={churchLogoImage && churchLogoImage.src ? churchLogoImage.src : ''}
                        alt={'The Church of Jesus Christ of Latter-day Saints'}
                    />
                </a>
                <a className='StoreLogo' href={storeLogoLink ? storeLogoLink.linkUrl.destinationUrl : ''}>
                    <img src={storeLogoImage && storeLogoImage.src ? storeLogoImage.src : ''} alt={'Online Store products and materials'} />
                </a>
            </div>
        </div>
    );
};
